import { getLatestFeatureMap } from './recoilState';

export function getFeatureMap() {
  return getLatestFeatureMap();
}
